import React from 'react';
import PropTypes from 'prop-types';
import {uid} from 'react-uid';
import {Box, Button} from '@tenancy.nz/design-system';

function Actions({items, sticky = false, sx = {}}) {
  const styles = {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-start',
    ...(sticky && {
      position: 'sticky',
      left: 0,
      bottom: 0,
      margin: '40px 0 0 0',
    }),
    ...sx,
  };
  if (items.length === 0) {
    return null;
  }
  return (
    <Box sx={styles}>
      {items.map(({text, ...item}, i) => (
        <Button
          key={uid({...item, text}, i)}
          color="primary"
          edges="rounded"
          {...item}>
          {text}
        </Button>
      ))}
    </Box>
  );
}

Actions.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sticky: PropTypes.bool,
  sx: PropTypes.shape({}),
};

export default Actions;
